// once we work on the functionality, the selectors will be created here
// sample code

import { createSelector } from 'reselect';
import { initState } from './reducer';

const authorizedReducer = (state) => state.authorized || initState;

const isAuthorisedLoading = createSelector(authorizedReducer, (cnter) => cnter.isAuthorisedLoading);

export default {
	isAuthorisedLoading
};
